module.exports = __webpack_public_path__ + "images/139_160.jpg";